import type { Configuration } from 'modules/integrations/hooks/SyncContext'

export const COMPENSATIONS_SYNC_CONFIGURATION: Configuration = {
  capabilityType: 'compensations',
}
